import { NgModule } from '@angular/core';
import { CART_BASE_FEATURE, CartBaseRootModule } from '@spartacus/cart/base/root';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [CartBaseRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_BASE_FEATURE]: {
          module: () => import('@spartacus/cart/base').then((m) => m.CartBaseModule),
        },
      },
    }),
  ],
})
export class CartBaseFeatureModule {}
